import { Input } from 'antd';
import { useEffect, useState } from 'react';

interface ICheckPoint {
  checkPoint: string;
  statusBox?: Boolean;
  point?: string;
  handleChange?: any;
}
function CheckPoint({
  checkPoint,
  statusBox,
  point,
  handleChange
}: ICheckPoint) {
  return (
    <div className="checkPoint" style={{ height: '130px' }}>
      <div
        className="wrapTitle"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <p>Check Point</p>
      </div>

      {statusBox ? (
        <Input defaultValue={checkPoint} onChange={handleChange} />
      ) : (
        <p className="descript" style={{ marginBottom: '0px' }}>
          {checkPoint}
        </p>
      )}
    </div>
  );
}

export default CheckPoint;
